import script from "./textstyle.vue?vue&type=script&lang=ts&setup=true"
export * from "./textstyle.vue?vue&type=script&lang=ts&setup=true"

import "./textstyle.vue?vue&type=style&index=0&id=fb20701e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb20701e"]])

export default __exports__